export default function parseCost(cost) {
  let formattedCost = "";
  if (cost <= 999) {
    formattedCost = formatCost(cost, 1, "");
  } else if (cost > 999 && cost < 1000000) {
    formattedCost = formatCost(cost, 1000, "k");
  } else {
    formattedCost = formatCost(cost, 1000000, "m");
  }
  return formattedCost;
}

function formatCost(cost, divider, trailingLetter) {
  let stringCost = "";
  cost = cost / divider;
  cost = Number(cost.toPrecision(3));
  stringCost = cost.toString() + trailingLetter;
  return stringCost;
}
